export { default } from "./diagram6.component";
